var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"tip":"Loading data...","spinning":_vm.loader}},[_c('div',{staticClass:"row",class:_vm.$style.padding,staticStyle:{"min-height":"100px"}},[(!_vm.loader)?_c('div',{staticClass:"col-md-12"},[_c('dynamic-table',{key:_vm.componentKey,attrs:{"propData":{
          columns: _vm.columnDefs,
          rows: _vm.form.takeoff,
          create: _vm.create,
          screen: 'Building Shell',
          constructionInfo: true,
          dropdownData: _vm.dropdownData,
          firstRowValues: _vm.form,
          constructionInfoData: _vm.form,
          tableId: (_vm.tableId + " buildingShell"),
          calculationData: _vm.projectData,
          buildingData: _vm.buildingData,
          assetId: _vm.projectData.assetId,
          assetNumber: _vm.projectData.assetNumber
        },"columnSettings":_vm.columnSettings,"screenId":3,"type":_vm.type,"tableId":_vm.tableId,"projectModule":true,"isArchive":_vm.isArchive},on:{"updateTakeOff":_vm.updateTakeOff,"updateColumnSettings":_vm.updateColumnSettings}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }